import { render, staticRenderFns } from "./EditContract.vue?vue&type=template&id=89f0591a&scoped=true&"
import script from "./EditContract.vue?vue&type=script&lang=js&"
export * from "./EditContract.vue?vue&type=script&lang=js&"
import style0 from "./EditContract.vue?vue&type=style&index=0&id=89f0591a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f0591a",
  null
  
)

export default component.exports